import React, { useState } from "react";
import "./ProductsPage.css";
import products from "../../data/products";
import ImageModal from "../common/ImageModal";

function ProductsPage() {
  const [filter, setFilter] = useState("All");
  const [selectedProduct, setSelectedProduct] = useState(null);

  const categories = ["All", "Home & Kitchen", "Electronics"];

  const filteredProducts =
    filter === "All" ? products : products.filter((p) => p.category === filter);

  return (
    <div className="ProductsPage">
      <div className="Products-header">
        <h2>Our Products</h2>
        <p>Explore our wide range of premium quality products.</p>
      </div>

      <div className="Category-filters">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`Filter-btn ${filter === cat ? "active" : ""}`}
            onClick={() => setFilter(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="Products-grid">
        {filteredProducts.map((product) => (
          <div className="Slide-item" key={product.id}>
            <div style={{ position: "relative", cursor: "pointer" }} onClick={() => setSelectedProduct(product)}>
              <img
                src={product.image}
                alt={product.title}
                className="Slide-image"
                title="Click to view all photos"
              />
              {product.images && product.images.length > 1 && (
                <span
                  style={{
                    position: "absolute",
                    bottom: 8,
                    right: 8,
                    background: "rgba(0,0,0,0.7)",
                    color: "#fff",
                    fontSize: "11px",
                    padding: "3px 7px",
                    borderRadius: "4px",
                    fontWeight: 600,
                  }}
                >
                  📷 {product.images.length} photos
                </span>
              )}
            </div>
            <div className="Slide-content">
              <h4 onClick={() => setSelectedProduct(product)} style={{ cursor: "pointer" }}>{product.title}</h4>
              <p>{product.description}</p>
              <div className="Slide-price">{product.price}</div>
              {product.affiliateUrl ? (
                <a
                  href={product.affiliateUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="Buy-button"
                >
                  Buy on{" "}
                  {product.affiliateUrl.includes("amazon") || product.affiliateUrl.includes("amzn")
                    ? "Amazon"
                    : "Flipkart"}
                </a>
              ) : (
                <a href={product.url} className="Buy-button">
                  View Details
                </a>
              )}
            </div>
          </div>
        ))}
      </div>

      {selectedProduct && (
        <ImageModal
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
        />
      )}
    </div>
  );
}

export default ProductsPage;
